import { IStyle, IToggleStyles } from '@fluentui/react';
import { FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IEditFeatureSetStyles {
  root?: IStyle;
  form?: IStyle;
  fields?: IStyle;
  fieldItem?: IStyle;
  subTitle?: IStyle;
  buttons?: IStyle;
}

export interface IEditFeatureSetClassNames {
  root: string;
  form: string;
  fields: string;
  fieldItem: string;
  subTitle: string;
  buttons: string;
}

export const editFeatureSetStylesDefault = (_theme: IH2OTheme): Partial<IEditFeatureSetStyles> => ({
  root: {
    flex: 1,
    paddingTop: 17,
    minHeight: 0,
  },
  form: { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    minHeight: 0,
    overflow: 'auto',
  },
  fieldItem: {
    display: 'flex',
    gap: 8,
    marginBottom: 16,
  },
  subTitle: {
    fontWeight: FontWeights.semiBold,
    paddingTop: 6,
  },
  buttons: { display: 'flex', justifyContent: 'space-between', marginTop: 16 },
});

export const toggleStylesEditFeatureSet: Partial<IToggleStyles> = {
  root: {
    justifyContent: 'space-between',
    marginRight: '70%',
  },
};
